<template>
    <CCard class="order-ah-card">
        <CCardHeader>
            <strong>Помощники</strong> <small>Подробности заказа</small>
        </CCardHeader>
        <CCardBody>
            <CTabs variant="tabs" :active-tab="0">
                <CTab title="Карточка" class="pt-1">
                    <CDataTable
                        hover
                        :items="enabledUnmodifiedItems"
                        :fields="unmodifiedFields">
                        <template #assistant="data">
                            <td>
                                <CLink
                                    :to="`/assistants/${data.item.assistant.id}`"
                                >{{ data.item.assistant.title }}</CLink
                                >
                            </td>
                        </template>

                        <template #service="data">
                            <td>
                                <CLink
                                    :to="`/assistants/${data.item.assistant.id}/service/${data.item.assistant_service.id}`"
                                >{{
                                    data.item.assistant_service_title
                                        ? data.item.assistant_service_title
                                        : data.item.assistant_service.title
                                }}</CLink
                                >
                            </td>
                        </template>

                        <template #options="data">
                            <td>
                                <span
                                    v-for="option in data.item.options"
                                    :key="option.title"
                                >
                                    {{ option.title }} -
                                    {{ option.price }}<br />
                                </span>
                            </td>
                        </template>

                        <template #extras="data">
                            <td>
                                <span
                                    v-for="extra in data.item.extras"
                                    :key="extra.title"
                                >
                                    {{ extra.title }} -
                                    {{ extra.price }}<br />
                                </span>
                            </td>
                        </template>

                        <template #price="data">
                            <td>
                                {{ formatPrice(data.item.price) }}
                                <span v-if="data.item.price && data.item.old_price && +data.item.price != +data.item.old_price">
                                    <span class="old-price">({{ formatPrice(data.item.old_price) }})</span>
                                </span>
                            </td>
                        </template>

                        <template #quantity="data">
                            <td>
                                {{ data.item.quantity }}
                            </td>
                        </template>

                        <template #price_total="data">
                            <td :class="{'red': data.item.not_added && (data.item.price != data.item.price_total), 'green': !data.item.not_added}">
                                {{ formatPrice(data.item.price_total) }}
                                <span v-if="data.item.price_total && data.item.old_price_total && +data.item.price_total != +data.item.old_price_total">
                                    <span class="old-price">({{ formatPrice(data.item.old_price_total) }})</span>
                                </span>
                            </td>
                        </template>

                        <template #quantity_total="data">
                            <td
                                :style="+data.item.quantity_total > 1 ? 'font-size: 200%' : ''"
                                :class="{'red': data.item.not_added && (data.item.quantity != data.item.quantity_total), 'green': !data.item.not_added}">
                                {{ data.item.quantity_total }}
                            </td>
                        </template>

                        <template #refund_for="data">
                            <td>
                                {{
                                    data.item && data.item.refund_for
                                        ? ` За счет ${data.item.refund_for}${data.item.refund_comment ? ' ('+data.item.refund_comment+')' : ''} - ${ formatPrice(data.item.refund_sum) }`
                                        : ''
                                }}
                            </td>
                        </template>

                        <template #sum="data">
                            <td>
                                {{ formatPrice(data.item.sum) }}
                            </td>
                        </template>

                        <template #sum_total="data">
                            <td class="blue">
                                {{ formatPrice(data.item.sum_total) }}
                            </td>
                        </template>

                        <template #edit> </template>
                    </CDataTable>
                </CTab>
                <CTab title="Редактировать" class="pt-1">
                    <CDataTable
                        hover
                        :items="enabledItems"
                        :fields="fields">
                        <template #assistant="data">
                            <td>
                                <CLink
                                    :to="`/assistants/${data.item.assistant.id}`"
                                >{{ data.item.assistant.title }}</CLink
                                >
                            </td>
                        </template>

                        <template #service="data">
                            <td>
                                <CLink
                                    :to="`/assistants/${data.item.assistant.id}/service/${data.item.assistant_service.id}`"
                                >{{
                                    data.item.assistant_service_title
                                        ? data.item.assistant_service_title
                                        : data.item.assistant_service.title
                                }}</CLink
                                >
                            </td>
                        </template>

                        <template #options="data">
                            <td>
                                <span
                                    v-for="option in data.item.options"
                                    :key="option.title"
                                >
                                    {{ option.title }} -
                                    {{ option.price }}
                                </span>
                            </td>
                        </template>

                        <template #extras="data">
                            <td>
                                <span
                                    v-for="extra in data.item.extras"
                                    :key="extra.title"
                                >
                                    {{ extra.title }} -
                                    {{ extra.price }}
                                </span>
                            </td>
                        </template>

                        <template #sum_total="data">
                            <td class="blue">
                                {{ formatPrice((data.item.price * data.item.quantity) - data.item.refund_sum) }}
                            </td>
                        </template>

                        <template #refund_for="data">
                            <td>
                                {{
                                    data.item && data.item.refund_for
                                        ? ` За счет ${data.item.refund_for}${data.item.refund_comment ? ' ('+data.item.refund_comment+')' : ''} - ${ formatPrice(data.item.refund_sum) }`
                                        : ''
                                }}
                            </td>
                        </template>

                        <template #quantity="data">
                            <td>
                                {{ data.item.quantity }}
                            </td>
                        </template>

                        <template #edit="data">
                            <td>
                                <CButton
                                    v-if="data.item.assistant_service_id"
                                    variant="ghost"
                                    color="primary"
                                    class="mb-1"
                                    @click="itemEdit(data.item.id)"
                                >
                                    <CIcon name="cil-pencil" /> </CButton
                                    ><br />
                                <CButton
                                    variant="ghost"
                                    color="danger"
                                    @click="itemDelete(data.item.id)"
                                >
                                    <CIcon name="cil-trash" />
                                </CButton>
                            </td>
                        </template>
                    </CDataTable>
                    <CRow>
                        <CCol class="form-group text-right">
                            <CButton
                                color="primary"
                                class="ml-3"
                                @click="itemAdd"
                            >Добавить услугу</CButton
                            >
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol class="form-group">
                            <CButton
                                color="primary"
                                class="mr-3"
                                @click="orderUpdate"
                            >Сохранить</CButton
                            >
                            <CButton
                                color="light"
                                class="mr-3"
                                @click="$emit('cancel')"
                            >Отмена</CButton
                            >
                        </CCol>
                    </CRow>
                </CTab>
            </CTabs>
        </CCardBody>

        <OrderAHItemEdit
            :modal="itemEditModal"
            @update="itemUpdate"
            @cancel="itemCancel"
        />
    </CCard>
</template>

<script>
    const { formatDate } = require('../../utils/views');
    import OrderAHItemEdit from './OrderAHItemEdit';

    export default {
        name: 'OrderAH',

        components: {
            OrderAHItemEdit,
        },

        props: {
            order: {
                type: Object,
                default: () => ({}),
            },
            orderUnmodified: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                isAuthorized: false,
                unmodifiedFields: [
                    { key: 'service', label: 'Услуга' },
                    { key: 'options', label: 'Варианты' },
                    { key: 'extras', label: 'Дополнительно' },
                    { key: 'quantity_total', label: 'Кол-во итог' },
                    { key: 'sum_total', label: 'Сумма итог' },
                    { key: 'price_total', label: 'Цена итог' },
                    { key: 'refund_for', label: 'Возврат' },
                    { key: 'quantity', label: 'Кол-во до' },
                    { key: 'sum', label: 'Сумма до' },
                    { key: 'price', label: 'Цена до' },
                ],
                fields: [
                    { key: 'service', label: 'Услуга' },
                    { key: 'options', label: 'Варианты' },
                    { key: 'extras', label: 'Дополнительно' },
                    { key: 'price', label: 'Цена' },
                    { key: 'quantity', label: 'Кол-во' },
                    { key: 'refund_for', label: 'Возврат' },
                    { key: 'sum_total', label: 'Сумма итог' },
                    { key: 'edit', label: '' },
                ],
                itemEditModal: {
                    item: {},
                    visible: false,
                    emptyItem: {
                        assistant: {},
                        service: {},
                        options: [],
                        extras: [],
                        refund_for: '',
                        refund_comment: '',
                        price: 0,
                        quantity: 1,
                        enabled: true,
                        applyDiscount: true
                    },
                },
            };
        },

        computed: {
            enabledItems() {
                return this.order.items ? this.order.items.filter(item => {
                    return item.enabled
                }) : [];
            },
            enabledUnmodifiedItems() {
                if(this.orderUnmodified.items) {
                    const orderItems = this.orderUnmodified.items.map(item => {
                        return {
                            ...item,
                            ...{
                            unique_id: item.assistant_service_id + item.extras.reduce((extra_unique, extra) => {
                                    return extra_unique + extra.id
                                }, '') + item.options.reduce((option_unique, option) => {
                                    return option_unique + option.id
                                }, '')
                        }
                        }
                    });
                    const enabled = orderItems.map(item => {
                        return {
                            ...item,
                            price: +item.price,
                            old_price: +item.old_price,
                            quantity_total: item.quantity,
                            price_total: +item.price,
                            old_price_total: +item.old_price,
                            sum_total: item.sum,
                        }
                    }).filter(item => item.enabled);
                    const disabled = orderItems.filter(item => !item.enabled);
                    for(let i=0; i < enabled.length; i++) {
                        for(let j=0; j < disabled.length; j++) {
                            if(enabled[i].unique_id === disabled[j].unique_id && !disabled[j].checked) {
                                enabled[i].not_added = true;
                                enabled[i].quantity = disabled[j].quantity;
                                enabled[i].price = disabled[j].price;
                                enabled[i].old_price = disabled[j].old_price;
                                enabled[i].sum = disabled[j].sum;
                                disabled[j].not_removed = true;
                                disabled[j].checked = true;
                            }
                        }
                    }
                    for(let j=0; j < disabled.length; j++) {
                        if(!disabled[j].not_removed) {
                            disabled[j].not_added = true;
                            disabled[j].removed = true;
                            disabled[j].quantity_total = 0;
                            disabled[j].price_total = 0;
                            disabled[j].sum_total = 0;
                            enabled.push(disabled[j]);
                        }
                    }
                    for(let i=0; i < enabled.length; i++) {
                        if(!enabled[i].not_added) {
                            enabled[i].quantity = 0;
                            enabled[i].price = 0;
                            enabled[i].sum = 0;
                        }
                        enabled[i].sum = enabled[i].quantity * enabled[i].price;
                        enabled[i].sum_total = enabled[i].quantity_total * enabled[i].price_total - enabled[i].refund_sum;
                    }

                    return enabled;
                }
                return [];
            },
        },

        watch: {},

        methods: {
            formatDate(date) {
                return formatDate(date);
            },
            formatPrice(price) {
                return (Math.round(price * 100) / 100).toFixed(2) + 'р.';
            },
            itemAdd() {
                this.itemEditModal.item = { ...this.itemEditModal.emptyItem, isNewPosition: true };
                this.itemEditModal.visible = true;
            },
            itemEdit(id) {
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === id) {
                        this.itemEditModal.item = JSON.parse(JSON.stringify(this.order.items[i]));
                        this.itemEditModal.visible = true;
                    }
                }
            },
            itemDelete(id) {
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === id) {
                        this.order.items.splice(i, 1);
                    }
                }
            },
            itemUpdate() {
                let items = [];
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === this.itemEditModal.item.id) {
                        items.push(this.itemEditModal.item);
                    } else {
                        items.push(this.order.items[i]);
                    }
                }
                if (!this.itemEditModal.item.id) {
                    this.itemEditModal.item.id = 'temp-' + this.order.items.length;
                    items.push(JSON.parse(JSON.stringify(this.itemEditModal.item)));
                }
                this.order.items = items;
                this.itemCancel();
            },
            itemCancel() {
                this.itemEditModal.item = this.itemEditModal.emptyItem;
                this.itemEditModal.visible = false;
            },
            orderUpdate() {
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id && this.order.items[i].id.toString().indexOf('temp-') >= 0) {
                        delete this.order.items[i].id;
                    }
                }
                this.$emit('update');
            },
        },
    };
</script>

<style>
.order-ah-card .table th,
.order-ah-card .table td {
    vertical-align: middle;
}
.order-ah-card .old-price {
    text-decoration: none;
    color: #a7a7a7;
}
.order-ah-card .green {
    /* color: #33d436 */
}
.order-ah-card .red {
    color: red
}
.order-ah-card .blue {
    color: blue;
}
</style>
